<template>
  <div>
    <div class="bottom-nav-bar">
      <div
        class="bottom-nav-bar-item"
        v-for="item in options"
        :key="item.key"
        @click="() => handleNavBarClick(item)"
      >
        <img
          class="bottom-nav-bar-icon"
          :src="curNav === item.key ? item.selectedIcon : item.defaultIcon"
        >
        <div
          class="bottom-nav-bar-text"
          :class="{
            active: curNav === item.key,
          }"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomNavBar',
  props: {
    curNav: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    handleNavBarClick(item) {
      console.log('handleNavBarClick', item.key);
      this.$emit('click', item.key);
    }
  }
};
</script>

<style lang="scss" scoped>
.bottom-nav-bar-seat {
  box-sizing: border-box;
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px rgba(227, 228, 230, 1);
}
.bottom-nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  width: 100vw;
  background: #ffffff;
  box-shadow: inset 0px 1px 0px 0px rgba(227, 228, 230, 1);

  .bottom-nav-bar-item {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 1;
    height: 100%;

    .bottom-nav-bar-icon {
      width: 54px;
      height: 54px;
      object-fit: contain;
      margin-bottom: 4px;
    }
    .bottom-nav-bar-text {
      font-size: 20px;
      color: #7f8389;
      letter-spacing: -0.93px;
      text-align: center;
      font-weight: 400;

      &.active {
        color: #fe7256;
      }
    }
  }
}
</style>
